'use strict';

var createAbortError = function createAbortError() {
  var error = new Error('Delay aborted');
  error.name = 'AbortError';
  return error;
};

var createDelay = function createDelay(_ref) {
  var defaultClear = _ref.clearTimeout,
      set = _ref.setTimeout,
      willResolve = _ref.willResolve;
  return function (ms) {
    var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        value = _ref2.value,
        signal = _ref2.signal;

    if (signal && signal.aborted) {
      return Promise.reject(createAbortError());
    }

    var timeoutId;
    var settle;
    var rejectFn;
    var clear = defaultClear || clearTimeout;

    var signalListener = function signalListener() {
      clear(timeoutId);
      rejectFn(createAbortError());
    };

    var cleanup = function cleanup() {
      if (signal) {
        signal.removeEventListener('abort', signalListener);
      }
    };

    var delayPromise = new Promise(function (resolve, reject) {
      settle = function settle() {
        cleanup();

        if (willResolve) {
          resolve(value);
        } else {
          reject(value);
        }
      };

      rejectFn = reject;
      timeoutId = (set || setTimeout)(settle, ms);
    });

    if (signal) {
      signal.addEventListener('abort', signalListener, {
        once: true
      });
    }

    delayPromise.clear = function () {
      clear(timeoutId);
      timeoutId = null;
      cleanup();
      settle();
    };

    return delayPromise;
  };
};

var delay = createDelay({
  willResolve: true
});
delay.reject = createDelay({
  willResolve: false
});

delay.createWithTimers = function (_ref3) {
  var clearTimeout = _ref3.clearTimeout,
      setTimeout = _ref3.setTimeout;
  var delay = createDelay({
    clearTimeout: clearTimeout,
    setTimeout: setTimeout,
    willResolve: true
  });
  delay.reject = createDelay({
    clearTimeout: clearTimeout,
    setTimeout: setTimeout,
    willResolve: false
  });
  return delay;
};

module.exports = delay; // TODO: Remove this for the next major release

module.exports.default = delay;